module.exports = __webpack_public_path__ + "img/gc_country_flag_ec.6d5ba84a.svg";